// src/hooks/pdf/useCertificateDownload.ts
import certificatePdfService from "../../services/pdf/CertificatePdfService";
import useLoading from "../useLoading";

const useCertificateDownload = () => {
  const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

  const handleDownloadCertificate = async () => {
    try {
      showLoadingIndicator(); // ⏳ Mostrar loader

      const { blob, fileName } = await certificatePdfService.download();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName || "Certificado_Codenova.pdf";
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("❌ Error descargando certificado:", err);
    } finally {
      hideLoadingIndicator(); // ✅ Siempre ocultar loader
    }
  };

  return { handleDownloadCertificate };
};

export default useCertificateDownload;
